import type { ChartRow } from "../types";
import { dateAxisFormatter, dateFullFormatter } from "./_dates";
import { humanizeColumn } from "./_humanize";
import { axisStyle, axisTooltip, baseLayout, columnIndex, pluck, valueAxisStyle } from "./_shared";

interface Input {
  x: string;
  y_series: string[];
}

export function buildLineTimeseries(
  input: Input,
  rows: ChartRow[],
  columns: string[],
  _title: string,
  palette: ReadonlyArray<string>,
) {
  const xIdx = columnIndex(columns, input.x);
  const rawX = pluck(rows, xIdx);
  const categories = rawX.map((v) => (v == null ? "—" : String(v)));

  const series = input.y_series.map((name) => {
    const idx = columnIndex(columns, name);
    return {
      name: humanizeColumn(name),
      type: "line" as const,
      data: pluck(rows, idx),
      smooth: true,
      symbol: "circle" as const,
      symbolSize: 6,
      lineStyle: { width: 2.5 },
      showSymbol: rows.length <= 40,
    };
  });

  const dateAxis = dateAxisFormatter(rawX);
  const dateFull = dateFullFormatter(rawX);
  return {
    ...baseLayout(),
    tooltip: axisTooltip(dateFull ?? undefined, input.y_series),
    color: [...palette],
    xAxis: {
      ...axisStyle,
      type: "category" as const,
      data: categories,
      boundaryGap: false,
      axisLabel: { ...axisStyle.axisLabel, ...(dateAxis ? { formatter: dateAxis } : {}), hideOverlap: true },
    },
    yAxis: { ...valueAxisStyle(input.y_series[0]), type: "value" as const },
    series,
  };
}
